import { ModuleWithProviders, NgModule } from '@angular/core';
import { HumanresourcesPersonnelSharedComponent } from './humanresources-personnel-shared.component';
import { HrPerOrganizationTreeModule } from './module/personnel/organization/component/hr-per-organization-tree/hr-per-organization-tree.module';
import { HrPerPersonnelSearchModule } from './module/personnel/personnel-operations/component/hr-per-personnel-search/hr-per-personnel-search.module';
import { PositionSearchModule } from './module/personnel/organization/position-search-component/position-search.module';
import { RoleSearchModule } from './module/personnel/organization/role-search/role-search.module';
import { NgxAngularQueryBuilderModule } from 'ngx-angular-query-builder';
import { TitleSearchModule } from "./module/personnel/organization/title-search/title-search.module";
import { TitleDropdownModule } from "./module/personnel/organization/title-dropdown/title-dropdown.module";

@NgModule({
    declarations: [HumanresourcesPersonnelSharedComponent],
    imports: [HrPerOrganizationTreeModule, HrPerPersonnelSearchModule, NgxAngularQueryBuilderModule, TitleDropdownModule],
    exports: [
        HumanresourcesPersonnelSharedComponent,
        HrPerOrganizationTreeModule,
        HrPerPersonnelSearchModule,
        PositionSearchModule,
        RoleSearchModule,
        TitleSearchModule,
        TitleDropdownModule
    ],
})
export class HumanresourcesPersonnelSharedModule {
    static forRoot(): ModuleWithProviders<HumanresourcesPersonnelSharedModule> {
        return {
            ngModule: HumanresourcesPersonnelSharedModule,
        };
    }
}
